import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../config';

function Unsubscribe() {
  const { email: encodedEmail } = useParams();
  const email = decodeURIComponent(encodedEmail || '');
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    if (!email) {
      setError('No email address provided for unsubscription.');
    }
  }, [email]);

  const handleUnsubscribe = async () => {
    if (!email) {
      setError('Email address is required to unsubscribe.');
      return;
    }
    setIsProcessing(true);
    setError('');
    setMessage('');
    try {
      await axios.delete(`${API_URL}/subscriptions/unsubscribe/${encodeURIComponent(email)}`);
      setMessage(`Successfully unsubscribed ${email}. We're sorry to see you go.`);
      // Optionally redirect after a few seconds
      setTimeout(() => navigate('/'), 5000);
    } catch (err) {
      console.error('Unsubscribe error:', err);
      setError(err.response?.data?.message || 'Failed to unsubscribe. Please try again or contact support.');
    }
    setIsProcessing(false);
  };

  return (
    <div className="container mx-auto px-4 py-8 max-w-md text-center">
      <h1 className="text-3xl font-bold text-gray-800 mb-6">Unsubscribe</h1>
      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4" role="alert">
          <strong className="font-bold">Error: </strong>
          <span className="block sm:inline">{error}</span>
        </div>
      )}
      {message && (
        <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4" role="alert">
          <strong className="font-bold">Success: </strong>
          <span className="block sm:inline">{message}</span>
        </div>
      )}
      {!message && email && (
        <div className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
          <p className="mb-6 text-gray-700">
            Are you sure you want to unsubscribe <strong className="font-semibold">{email}</strong> from our newsletter?
          </p>
          <button
            onClick={handleUnsubscribe}
            disabled={isProcessing}
            className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full disabled:opacity-50"
          >
            {isProcessing ? 'Processing...' : 'Yes, Unsubscribe Me'}
          </button>
          <button
            onClick={() => navigate('/')}
            className="mt-4 text-blue-500 hover:text-blue-700 text-sm"
          >
            No, take me back to the homepage
          </button>
        </div>
      )}
      {!email && !error && (
        <p className="text-gray-600">Loading unsubscribe details...</p>
      )}
    </div>
  );
}

export default Unsubscribe; 